/**
 * テーブル表示モード
 */
export const TableDisplayMode = {
  // 参照
  reference: 'reference',
  // チェックボックス
  check: 'check',
  // ラジオボタン
  radio: 'radio',
  // その他
  other: 'other',
} as const;

